import * as React from "react";
import MainFooter from "./MainFooter";
import { MdKeyboardArrowUp } from "react-icons/md";
import PageTransitionOverlay from "../components/PageTransitionOverlay";

type MainLayoutProps = {
    children: React.ReactNode;
};

const ScrollToTop: React.FC = () => {
    const [visible, setVisible] = React.useState(false);

    React.useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 300);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            aria-label="Scroll to top"
            className={`fixed bottom-5 right-5 z-50 w-8 h-8 hidden md:flex items-center justify-center
                        bg-primary text-white rounded-full shadow-lg
                        transition-all duration-300
                        ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}
        >
            <MdKeyboardArrowUp size={20} />
        </button>
    );
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    return (
        <>
            {children}
            <MainFooter />
            <ScrollToTop />
        </>
    );
};

export default MainLayout;
